/* Signe R4 5/8: alle vandrette karruseller skal kunne trækkes med musen.
   Generisk: enhver forfader med overflow-x auto/scroll og reelt overløb bliver
   drag-scrollbar ved mouse-pointerdown. Touch beholder nativ swipe; pile virker
   fortsat. Klik efter et træk annulleres, så links/knapper ikke udløses ved drag. */
(function () {
  function scroller(el) {
    while (el && el !== document.body) {
      var cs = getComputedStyle(el);
      if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 2) return el;
      el = el.parentElement;
    }
    return null;
  }
  var st = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var el = scroller(e.target);
    if (!el) return;
    st = { el: el, x: e.clientX, left: el.scrollLeft, dragged: false };
  });
  document.addEventListener('dragstart', function (e) {
    if (st) e.preventDefault();
  });
  document.addEventListener('pointermove', function (e) {
    if (!st) return;
    var dx = e.clientX - st.x;
    if (!st.dragged && Math.abs(dx) > 5) {
      st.dragged = true;
      st.el.style.scrollBehavior = 'auto';
      st.el.style.scrollSnapType = 'none';
      st.el.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
    }
    if (st.dragged) st.el.scrollLeft = st.left - dx;
  });
  function end() {
    if (!st) return;
    var was = st.dragged, el = st.el;
    st = null;
    document.body.style.userSelect = '';
    el.style.scrollBehavior = '';
    el.style.scrollSnapType = '';
    el.style.cursor = '';
    if (was) {
      var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      document.addEventListener('click', kill, true);
      setTimeout(function () { document.removeEventListener('click', kill, true); }, 50);
    }
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
})();
